var _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.24,
    y: 133.66,
    width: 8.31,
    height: 8.31,
    transform: "translate(-25.21 38.74) rotate(-12.15)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.26,
    cy: 183.65,
    r: 45.81,
    transform: "translate(-13.69 352.85) rotate(-86.94)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.26,
    cy: 183.65,
    r: 39.88,
    transform: "translate(-75.57 153.31) rotate(-38.9)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.51,
    y: 126.64,
    width: 14.97,
    height: 9.37,
    transform: "translate(-23.88 38.3) rotate(-12.15)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.06,182.83a3.88,3.88,0,1,1-4.61-3A3.88,3.88,0,0,1,183.06,182.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.67,151.45c1.21,2.56,2.25,5.17,3.3,7.78l1.5,3.93,1.42,4c1,2.64,1.83,5.3,2.68,8s1.68,5.34,2.45,8l-3-.82q2.72-2.49,5.49-4.92c1.85-1.62,3.73-3.21,5.62-4.77s3.82-3.11,5.76-4.63,3.93-3,6-4.38c-1.55,2-3.18,3.8-4.82,5.64s-3.32,3.64-5,5.4-3.43,3.53-5.18,5.25-3.52,3.43-5.32,5.1l-2.14,2-.87-2.82c-.82-2.68-1.59-5.37-2.34-8.07s-1.47-5.4-2.13-8.13l-1-4.09-.89-4.11C170.61,157,170.05,154.25,169.67,151.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.43,163.24l-36,104.57L242,217.77l36-104.58,4.89,1.68a3.17,3.17,0,1,0,5.06,3.43,3,3,0,0,0,.11-1.65l4.88,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,0,0,6,2.06,3,3,0,0,0,.1-1.65l4.88,1.67a3,3,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.67a3.17,3.17,0,1,0,5.06,3.43,3.11,3.11,0,0,0,.11-1.65l4.87,1.68a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6.1.41l4.87,1.67a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,0,0,6,2.06,3.13,3.13,0,0,0,.11-1.65l4.87,1.67a3.17,3.17,0,1,0,5.06,3.43,3,3,0,0,0,.11-1.65l4.87,1.68a3.17,3.17,0,1,0,5.07,3.42,3,3,0,0,0,.1-1.65l4.88,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,1,0,6.1.41l4.87,1.67a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,0,0,6,2.06,3.13,3.13,0,0,0,.11-1.65l4.87,1.67a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.68a3.07,3.07,0,0,0-.93,1.36,3.17,3.17,0,1,0,6,2.06,3.11,3.11,0,0,0,.11-1.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.43,163.24l-7.33,21.31-145.49-50,7.33-21.32,4.89,1.68a3.17,3.17,0,1,0,5.06,3.43,3,3,0,0,0,.11-1.65l4.88,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,0,0,6,2.06,3,3,0,0,0,.1-1.65l4.88,1.67a3,3,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.67a3.17,3.17,0,1,0,5.06,3.43,3.11,3.11,0,0,0,.11-1.65l4.87,1.68a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6.1.41l4.87,1.67a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,0,0,6,2.06,3.13,3.13,0,0,0,.11-1.65l4.87,1.67a3.17,3.17,0,1,0,5.06,3.43,3,3,0,0,0,.11-1.65l4.87,1.68a3.17,3.17,0,1,0,5.07,3.42,3,3,0,0,0,.1-1.65l4.88,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,1,0,6.1.41l4.87,1.67a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.68a3,3,0,0,0-.93,1.37,3.17,3.17,0,0,0,6,2.06,3.13,3.13,0,0,0,.11-1.65l4.87,1.67a3.1,3.1,0,0,0-.93,1.37,3.17,3.17,0,1,0,6,2.06,3.12,3.12,0,0,0,.11-1.65l4.87,1.68a3.07,3.07,0,0,0-.93,1.36,3.17,3.17,0,1,0,6,2.06,3.11,3.11,0,0,0,.11-1.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.63,
    y: 156.88,
    width: 16.85,
    height: 16.85,
    transform: "translate(71.18 -95.12) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.69,
    y: 163.44,
    width: 16.85,
    height: 16.85,
    transform: "translate(74.34 -100.96) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.74,
    y: 169.99,
    width: 16.85,
    height: 16.85,
    transform: "translate(77.51 -106.8) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.8,
    y: 176.55,
    width: 16.85,
    height: 16.85,
    transform: "translate(80.68 -112.64) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.85,
    y: 183.1,
    width: 16.85,
    height: 16.85,
    transform: "translate(83.85 -118.48) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.32,
    y: 161.8,
    width: 16.85,
    height: 16.85,
    transform: "translate(70.37 -80.43) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.37,
    y: 168.36,
    width: 16.85,
    height: 16.85,
    transform: "translate(73.53 -86.28) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.43,
    y: 174.91,
    width: 16.85,
    height: 16.85,
    transform: "translate(76.7 -92.12) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.48,
    y: 181.47,
    width: 16.85,
    height: 16.85,
    transform: "translate(79.87 -97.96) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.54,
    y: 188.02,
    width: 16.85,
    height: 16.85,
    transform: "translate(83.04 -103.8) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.6,
    y: 194.58,
    width: 16.85,
    height: 16.85,
    transform: "translate(86.21 -109.64) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.65,
    y: 201.13,
    width: 16.85,
    height: 16.85,
    transform: "translate(89.38 -115.49) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.12,
    y: 179.83,
    width: 16.85,
    height: 16.85,
    transform: "translate(75.89 -77.44) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.17,
    y: 186.39,
    width: 16.85,
    height: 16.85,
    transform: "translate(79.06 -83.28) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.23,
    y: 192.94,
    width: 16.85,
    height: 16.85,
    transform: "translate(82.23 -89.12) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.28,
    y: 199.5,
    width: 16.85,
    height: 16.85,
    transform: "translate(85.4 -94.96) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.34,
    y: 206.05,
    width: 16.85,
    height: 16.85,
    transform: "translate(88.57 -100.8) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.4,
    y: 212.61,
    width: 16.85,
    height: 16.85,
    transform: "translate(91.73 -106.65) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.45,
    y: 219.16,
    width: 16.85,
    height: 16.85,
    transform: "translate(94.9 -112.49) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.91,
    y: 197.86,
    width: 16.85,
    height: 16.85,
    transform: "translate(81.42 -74.44) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.97,
    y: 204.42,
    width: 16.85,
    height: 16.85,
    transform: "translate(84.59 -80.28) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.03,
    y: 210.97,
    width: 16.85,
    height: 16.85,
    transform: "translate(87.76 -86.12) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.08,
    y: 217.52,
    width: 16.85,
    height: 16.85,
    transform: "translate(90.92 -91.97) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.14,
    y: 224.08,
    width: 16.85,
    height: 16.85,
    transform: "translate(94.09 -97.81) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.19,
    y: 230.63,
    width: 16.85,
    height: 16.85,
    transform: "translate(97.26 -103.65) rotate(18.98)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,202.1a1.51,1.51,0,0,1-1.35-.84l-10.45-21.42a1.5,1.5,0,1,1,2.69-1.31L339.49,200a1.5,1.5,0,0,1-.69,2A1.41,1.41,0,0,1,338.14,202.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.2,196.62a1.5,1.5,0,0,1-.66-2.85L343,183.32a1.5,1.5,0,0,1,1.32,2.7l-21.42,10.45A1.55,1.55,0,0,1,322.2,196.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.83,152.88v6.64l3.41.32A18.07,18.07,0,0,0,86.79,166l-2.19,2.65,4.69,4.69,2.65-2.2a17.52,17.52,0,0,0,6.13,2.55l.32,3.41H105l.32-3.41a17.6,17.6,0,0,0,6.13-2.55l2.65,2.2,4.69-4.69L116.62,166a17.86,17.86,0,0,0,2.54-6.13l3.42-.32v-6.64l-3.42-.32a17.86,17.86,0,0,0-2.54-6.13l2.19-2.65-4.69-4.69-2.65,2.2a17.6,17.6,0,0,0-6.13-2.55l-.32-3.42H98.39l-.32,3.42a17.52,17.52,0,0,0-6.13,2.55l-2.65-2.2-4.69,4.69,2.19,2.65a18.07,18.07,0,0,0-2.55,6.13Zm20.87-5.66a9,9,0,1,1-9,9A9,9,0,0,1,101.7,147.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.51,312.11a30.63,30.63,0,0,0,10.57-4.4l4.58,3.79,8.1-8.1L258,298.83a30.68,30.68,0,0,0,4.4-10.58l5.89-.55V276.25l-5.89-.56a30.68,30.68,0,0,0-4.4-10.58l3.79-4.57-8.1-8.1-4.58,3.79a30.63,30.63,0,0,0-10.57-4.4l-.56-5.89H226.5l-.55,5.89a30.68,30.68,0,0,0-10.58,4.4l-4.57-3.79-8.1,8.1,3.79,4.57a30.68,30.68,0,0,0-4.4,10.58l-5.89.56V287.7l5.89.55a30.68,30.68,0,0,0,4.4,10.58l-3.79,4.57,8.1,8.1,4.57-3.79a30.68,30.68,0,0,0,10.58,4.4l.55,5.89H238ZM216.73,282a15.5,15.5,0,1,1,15.5,15.5A15.5,15.5,0,0,1,216.73,282Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,360.73l1.74,1.44,3.09-3.09-1.45-1.74a11.5,11.5,0,0,0,1.68-4l2.25-.21v-4.37l-2.25-.21a11.34,11.34,0,0,0-1.68-4l1.45-1.75-3.09-3.09L111,341.1a11.47,11.47,0,0,0-4-1.68l-.21-2.25h-4.36l-.22,2.25a11.5,11.5,0,0,0-4,1.68l-1.74-1.45-3.09,3.09,1.44,1.75a11.51,11.51,0,0,0-1.67,4l-2.25.21v4.37l2.25.21a11.67,11.67,0,0,0,1.67,4l-1.44,1.74,3.09,3.09,1.74-1.44a11.67,11.67,0,0,0,4,1.67l.22,2.25h4.36l.21-2.25A11.64,11.64,0,0,0,111,360.73Zm-12.34-9.82a5.91,5.91,0,1,1,5.91,5.91A5.91,5.91,0,0,1,98.63,350.91Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,132.07l1,.84,1.79-1.79-.83-1a6.83,6.83,0,0,0,1-2.34l1.3-.12v-2.53l-1.3-.12a6.83,6.83,0,0,0-1-2.34l.83-1L237,119.86l-1,.84a6.66,6.66,0,0,0-2.33-1l-.13-1.31H231l-.12,1.3a6.84,6.84,0,0,0-2.34,1l-1-.84-1.78,1.79.83,1a6.83,6.83,0,0,0-1,2.34l-1.3.12v2.53l1.3.12a6.83,6.83,0,0,0,1,2.34l-.83,1,1.78,1.79,1-.84a6.63,6.63,0,0,0,2.34,1l.12,1.3h2.53l.13-1.3A6.66,6.66,0,0,0,236,132.07Zm-7.15-5.69a3.43,3.43,0,1,1,3.43,3.43A3.43,3.43,0,0,1,228.8,126.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,124.11l1,.84,1.79-1.79-.84-1a6.63,6.63,0,0,0,1-2.34l1.31-.12v-2.53l-1.31-.13a6.66,6.66,0,0,0-1-2.33l.84-1-1.79-1.79-1,.84a6.84,6.84,0,0,0-2.34-1l-.12-1.3h-2.53l-.12,1.3a6.84,6.84,0,0,0-2.34,1l-1-.84L379,113.69l.84,1a6.66,6.66,0,0,0-1,2.33l-1.31.13v2.53l1.31.12a6.63,6.63,0,0,0,1,2.34l-.84,1,1.79,1.79,1-.84a6.63,6.63,0,0,0,2.34,1l.12,1.3h2.53l.12-1.3A6.63,6.63,0,0,0,389.28,124.11Zm-7.15-5.69a3.43,3.43,0,1,1,3.43,3.43A3.42,3.42,0,0,1,382.13,118.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.15,284.13l1.74,1.44,3.09-3.08-1.44-1.75a11.67,11.67,0,0,0,1.67-4l2.25-.21v-4.37l-2.25-.21a11.59,11.59,0,0,0-1.67-4l1.44-1.75-3.09-3.09-1.74,1.45a11.88,11.88,0,0,0-4-1.68l-.22-2.25h-4.36l-.21,2.25a11.85,11.85,0,0,0-4,1.68l-1.74-1.45-3.09,3.09,1.45,1.75a11.42,11.42,0,0,0-1.68,4l-2.25.21v4.37l2.25.21a11.5,11.5,0,0,0,1.68,4l-1.45,1.75,3.09,3.08,1.74-1.44a11.85,11.85,0,0,0,4,1.68l.21,2.24h4.36l.22-2.24A11.88,11.88,0,0,0,422.15,284.13Zm-12.34-9.82a5.91,5.91,0,1,1,5.91,5.91A5.92,5.92,0,0,1,409.81,274.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,378.85l2.76,2.28,4.88-4.88-2.28-2.76a18.48,18.48,0,0,0,2.65-6.38l3.55-.33v-6.9l-3.55-.34a18.51,18.51,0,0,0-2.65-6.37l2.28-2.76L305,345.53l-2.76,2.28a18.51,18.51,0,0,0-6.37-2.65l-.34-3.55h-6.9l-.33,3.55a18.48,18.48,0,0,0-6.38,2.65l-2.76-2.28-4.88,4.88,2.28,2.76a18.51,18.51,0,0,0-2.65,6.37l-3.55.34v6.9l3.55.33a18.48,18.48,0,0,0,2.65,6.38l-2.28,2.76,4.88,4.88,2.76-2.28a18.48,18.48,0,0,0,6.38,2.65l.33,3.55h6.9l.34-3.55A18.51,18.51,0,0,0,302.22,378.85Zm-19.5-15.52a9.35,9.35,0,1,1,9.34,9.34A9.35,9.35,0,0,1,282.72,363.33Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hourglass--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.88,193.43C108.54,199,83.28,209,84.44,215.79l.55,3.14h0c1.16,6.75,28.33,7.7,60.66,2.1s57.61-15.6,56.44-22.35l-.54-3.14C200.38,188.78,173.22,187.84,140.88,193.43Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.54,
    cy: 208.8,
    rx: 59.42,
    ry: 12.41,
    transform: "translate(-33.48 27.51) rotate(-9.81)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.58,203.25c-29,5-51.58,14-50.53,20l.9,5.23h0c1,6.05,25.37,6.89,54.32,1.88s51.58-14,50.53-20h0l-.9-5.22C195.85,199.09,171.53,198.24,142.58,203.25Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.38,
    cy: 219.43,
    rx: 53.2,
    ry: 11.11,
    transform: "translate(-35.27 27.98) rotate(-9.81)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,282.64a9.26,9.26,0,0,1-2.51-14.48c11.73-12.77,25.93-33.1,22.33-54-.78-4.47-22.34-4.48-48.16,0s-46.13,11.72-45.36,16.19c3.61,20.87,23.81,35.25,39.15,43.34a9.26,9.26,0,0,1,2.51,14.48c-11.74,12.76-25.94,33.09-22.33,54,.78,4.48,22.34,4.49,48.16,0S212.73,330.45,212,326C208.35,305.1,188.14,290.72,172.81,282.64Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81,282.64a9.26,9.26,0,0,1-2.51-14.48c11.73-12.77,25.93-33.1,22.33-54-.78-4.47-22.34-4.48-48.16,0s-46.13,11.72-45.36,16.19c3.61,20.87,23.81,35.25,39.15,43.34a9.26,9.26,0,0,1,2.51,14.48c-11.74,12.76-25.94,33.09-22.33,54,.78,4.48,22.34,4.49,48.16,0S212.73,330.45,212,326C208.35,305.1,188.14,290.72,172.81,282.64Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.66,327.17c.46,4.69-82.72,20.88-88.25,13.69a5.84,5.84,0,0,1-.62-5.55,15.88,15.88,0,0,1,2.48-4.61c2.57-3.48,8.24-5,12.08-6.4,2.59-.95,5.2-1.82,7.81-2.72,2.8-1,5.68-.3,8.11-2.43,1.46-1.27,2.55-3.16,4.42-3.62,1.39-.34,2.88.21,4.25-.16,1.78-.48,3.05-2.4,4.89-2.43a11.56,11.56,0,0,1,2.67.65c1.6.34,3.24-.19,4.88-.34a20.53,20.53,0,0,1,4.82.35,146.72,146.72,0,0,0,15,2.07c3.71.2,7.82.11,11.44,1.13a6.9,6.9,0,0,1,3.68,3.24h0A17.38,17.38,0,0,1,209.66,327.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.08,317c.07,0,0,0-.17,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.35,320c-2.3-2.08-6.55-1.94-7.77-1.85s-1.65-.95-2.57-1.29-6.36.36-6.36.36,2,.39,2.42,1.05,2.7-.1,3-.19c-.31.18-3.09,1.64-4.4.76s-1.85.76-2.89,1.18-4.32,0-4.85-.17a41.42,41.42,0,0,0-4.7,0,6.69,6.69,0,0,1,2.68-1c.88.1,4.39-1.75,3.67-1.62s-2.36-.83-3.64-1.23a17.09,17.09,0,0,0-4.64.3,15.13,15.13,0,0,1,4.59.64,21.71,21.71,0,0,0-3,.95,9.8,9.8,0,0,1-2.76.47,3.86,3.86,0,0,0-1.86,1.44,28.59,28.59,0,0,1-3.47.6,8.42,8.42,0,0,1-3.41-.4l3.16-1-1.08-.31a12.58,12.58,0,0,0-2.28-.53c-1.27-.21-1.81,1-2.12,1.29s-3.09,0-3.87-.19-6.55,2.15-6.55,2.15l3.61-.62a8.83,8.83,0,0,0,2.95.69c2.41.32,2.76-.48,3.77-.41s4.36,1,4.36,1l-1.3.35a12.53,12.53,0,0,1-3.46,0c-2-.27-3.08.78-3.68.89a30.82,30.82,0,0,1-4.69.68c-.65-.14-2.36.66-3.3,1.62a4.11,4.11,0,0,1-4.16,1c-1.82-.47-4.89,1.75-4.89,1.75s1.61-2.13,2.45-2.28a22.9,22.9,0,0,0,3.75-1.88,7.14,7.14,0,0,0-1.34.11,3.39,3.39,0,0,1-2.49-.81c-1-.69-2-.15-3.47.6s-3.05,1.64-4.6.55-6.3,2.94-6.3,2.94a17.89,17.89,0,0,0,3.15-1.08c.44-.36.75,0,2.15.29s1.86-.69,2.55-1.06,2.76.25,2.76.25a3.11,3.11,0,0,1-1.57.29c-.76-.12-2,2.07-2.4,1.83s-3.31.14-4.56.79-3.09,2.82-4.94,2.15c-1.57-.57-5.11,4.24-8.22,4.3a15.88,15.88,0,0,1,2.48-4.61c2.57-3.48,8.24-5,12.08-6.4,2.59-.95,5.2-1.82,7.81-2.72,2.8-1,5.68-.3,8.11-2.43,1.46-1.27,2.55-3.16,4.42-3.62,1.39-.34,2.88.21,4.25-.16,1.78-.48,3.05-2.4,4.89-2.43a11.56,11.56,0,0,1,2.67.65c1.6.34,3.24-.19,4.88-.34a20.53,20.53,0,0,1,4.82.35,146.72,146.72,0,0,0,15,2.07c3.71.2,7.82.11,11.44,1.13A6.9,6.9,0,0,1,207.35,320Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.8,326c-29,5-51.58,14-50.54,20l.91,5.23h0c1,6,25.36,6.89,54.32,1.88s51.58-14,50.53-20h0l-.9-5.22C217.07,321.79,192.75,320.94,163.8,326Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.41,335.3c-32.33,5.59-57.6,15.6-56.43,22.36l.54,3.13h0c1.17,6.76,28.33,7.7,60.67,2.11s57.6-15.6,56.43-22.36l-.54-3.13C224.91,330.65,197.75,329.71,165.41,335.3Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.16,366.48l-2.34-.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.06,360.59l-.21,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7,365c.32.09.66.17,1,.25C116.36,365.13,116,365.05,115.7,365Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.41,335.3c-32.33,5.59-57.6,15.6-56.43,22.36l.54,3.13a4.06,4.06,0,0,0,2.21,2.64,4.06,4.06,0,0,1-2.21-2.64C108.35,354,133.62,344,166,338.44s59.49-4.65,60.66,2.1h0l-.54-3.13C224.91,330.65,197.75,329.71,165.41,335.3Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,274.28c-.63,5-2.46,12.57-3.28,17.62s1.64,12.88,2.37,15.25,5.66,2,5.46,3.89,7.36,2.21,7.36,2.21-35.42,14-39,13.11,6.64-7.88,8.6-8.34,3-1.67,4.32-4.47,2.68-2.3,4.06-5.11a63.39,63.39,0,0,0,3.32-6.49c1.57-3.9,2.93-15.89,1.28-16.9s-.15,9.19-1.57,9.53,1.85-10.08-2.46-15.34S160.47,274.28,160.47,274.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.37,313.25s-35.41,14-39,13.11c-3.27-.81,5.09-6.8,8-8.11.19,2.06,5.74-.05,7.94-1.27s2.37-.33,3.18-.69,6.95-4.94,6.31-4.75-5.21,3.56-6.31,2.46-2.92,1-4.28,1.64c-1.18.57-1.48-.12-2.46-1,.19-.35.37-.73.56-1.13,1.29-2.8,2.67-2.3,4-5.11A60.79,60.79,0,0,0,153.7,302c1.58-3.9,2.94-15.89,1.3-16.9s-.16,9.19-1.57,9.52,1.83-10.07-2.47-15.33,9.51-5,9.51-5c-.63,5-2.46,12.57-3.28,17.62-.54,3.31.33,7.81,1.2,11.19-.23.82-.55,1.57-.93,1.69-.91.27-1.55,3.38-2.74,3.47s-.19,2.28,1.46,1.37c1.09-.6,2.81-1,4-1.52,1.54,1.37,5,1.35,4.82,2.94C164.83,312.94,172.37,313.25,172.37,313.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.68,251.42l-.42.69a84.83,84.83,0,0,1-4.52,7.18,44.46,44.46,0,0,1-5.43,6.87c-1.92,1.85-3.88,2.72-5,4.93a7.72,7.72,0,0,0-.65,1.73c-.42,1.67-.55,3.68-2,4.62a7.55,7.55,0,0,0-1,.61c-.73.63-.69,1.73-.88,2.67s-1.1,2-2,1.54-.94-1.61-1.75-1.57a3.12,3.12,0,0,0-.59.19c-.82.21-1.58-.43-2.21-1s-1.53-1.09-2.25-.65a40.15,40.15,0,0,0-7.14-5.23c-2.08-1.26-4.24-2.39-6.51-3.61-5-2.72-10.8-5.4-14.3-8.16a10.06,10.06,0,0,1-2.79-3.1,4,4,0,0,1-.4-1.29c-.58-4.94,14.71-6.41,20-10.09s13.55-1.32,17-2.09,7.38.32,11.05.05,5.93-1.33,8.07.23,4.51,1.09,5,2.28C181.2,249,180.3,250.44,179.68,251.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,249.86c-3.16-.61,3.29-.73,2.8-1.1s-2.07-1.57-5.59-1.45-6.46-.12-7.21,0,2.45,1.09,2.45,1.09H159.2c-2.68,0,1.83-1.09,1.83-1.09H147.14c.37,0,3.05,1.58,1.46,1.58s-3.29.85-5.48,1.7a37.31,37.31,0,0,1-5.35,1.71c-.36,0,5-4,5.33-4.26-.33.14-4.8,2-6.67,2.55s-7,2.32-7.44,2.44a21.6,21.6,0,0,0,2.81,0s-3.78,1.95-5.72,2.19c-1.46.18-5,1.38-5.86,3.92a10.06,10.06,0,0,0,2.79,3.1c3.5,2.76,9.28,5.44,14.3,8.16,2.27,1.22,4.43,2.35,6.51,3.61a40.15,40.15,0,0,1,7.14,5.23c.72-.44,1.63.1,2.25.65s1.39,1.2,2.21,1a3.12,3.12,0,0,1,.59-.19c.81,0,1,1.2,1.75,1.57s1.75-.6,2-1.54.15-2,.88-2.67a7.55,7.55,0,0,1,1-.61c1.46-.94,1.59-2.95,2-4.62a7.72,7.72,0,0,1,.65-1.73c1.15-2.21,3.11-3.08,5-4.93a44.46,44.46,0,0,0,5.43-6.87,84.83,84.83,0,0,0,4.52-7.18C178.14,250.21,178.19,250.47,175,249.86Zm-45.23,12.91c-1.06-.12,2.37-1.19,2.37-1.19A2.57,2.57,0,0,1,129.79,262.77Zm.64-4.11s1.73-1.37,2.46-1.28a15.37,15.37,0,0,0,2.11,0S132.26,259.21,130.43,258.66Zm13.79,10.69c-1.25-.24,1.32-1,1.94-.83S145.68,269.62,144.22,269.35Zm6.17-14s-5.3,1.56-4.23,1.56h2c-.37,0-5.85,1.19-6.12,1.14a25.77,25.77,0,0,1,3.26-1.84s-.39-.49-.37-.67,1.24-.55,1.24-.55c.43-.37,2.35-.91,3.08-.46a7,7,0,0,0,2.65.46Zm2.23,10.87c-1.48-1.35,2.91,0,2.91,0S153.62,267.15,152.62,266.24ZM155,251.72c2-1.37,2.5,0,2.5,0S154.35,252.16,155,251.72Zm6.93,5.3-1.54-.79a5.73,5.73,0,0,1,2.1-.76,4.9,4.9,0,0,1,2.83.76C165.86,256.56,162.46,257.29,161.92,257Zm3.94,6.72s-2.46-.06-2.7,0a21,21,0,0,1,2.7-.95Zm3.82-9.89s1.75-.38,2.57.53C173.36,255.6,169.68,253.85,169.68,253.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.54,394.88l8.06,2.43h44.07l1-17.66L364.12,376s1.59-13.65,4.14-28.28l5.85-.18,12.42-49-7.06-3.05,5.11-16.23h7.67l8.18-22.76S371,244.79,353.52,243.24l-15.7,2.63-1.09,20.44L323.94,268l-2.51,22,9.09,1.56-5.85,46.8-13.13,3.69-2.29,32.23,11.43,2.35Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,279.27l-5.12,16.23,7.06,3.05-12.43,49-5.84.18c-2.56,14.63-4.14,28.28-4.14,28.28l8.53,3.65-1,17.67H327.59l-8.06-2.43,1.16-18.23-11.44-2.34,2.23-31.44.06-.79,13.14-3.69,5.84-46.8L321.43,290,324,268l12.78-1.69,1.1-20.44,15.69-2.64c17.52,1.56,46.91,13.27,46.91,13.27l-8.18,22.77Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.65 379.64 329.05 380.86 320.69 376.65 330.27 378.43 364.12 375.99 372.65 379.64",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 347.71 336.73 347.81 311.48 342.87 311.54 342.08 324.68 338.39 338.56 346.71 368.26 347.71",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.47 295.5 340.57 291.69 330.52 291.59 321.43 290.03 340.01 287.9 379.47 295.5",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.25 279.27 384.58 279.27 353.89 265.25 336.73 266.31 354.83 263.97 392.25 279.27",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.52 243.23 354.83 263.97 336.73 266.31 337.82 245.88 353.52 243.23",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.01 287.9 345.01 266.31 323.95 268 321.43 290.03 340.01 287.9",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.52 291.59 349.57 292.57 338.56 346.71 324.68 338.39 330.52 291.59",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.48 342.87 336.73 347.81 331.63 378.33 309.25 374.31 311.48 342.87",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.05 380.86 327.59 397.31 319.53 394.88 320.69 376.66 329.05 380.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.4 349.69 335.57 354.74 361.69 353.59 336.73 359.19 313.4 349.69",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.35 381.97 328.51 386.98 348.23 386.98 324.29 388.9 316.27 383.42 320.35 381.97",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.13 391.86 371.98 391.86 376 394.88 337.13 391.86",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.97 362.78 310.45 357.32 306.96 359.19 329.97 362.78",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.81 370.45 365.15 367.94 368.26 369.19 335.81 370.45",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.01 338.39 376.71 337.25 379.47 339.58 345.01 338.39",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 331.73 342.21 328.77 326.13 322.78 320.69 322.78 339.87 330.82 368.26 331.73",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 308.35 345.4 313.08 386.41 316.39 382.71 313.64 345.01 311.27 332.25 308.35",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.73 280.96 318.46 281.87 322.99 284.06 336.73 280.96",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.05 273.47 342.94 271.62 378.74 284.06 342.75 274.75 329.05 273.47",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.44 266.31 352.07 254.77 330.88 261.41 337.13 263.09 354.83 260.54 373.44 266.31",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.86 258.31 399.01 271.62 395 271.62 366.86 258.31",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,248.26l16.07,1.83,25,13.88S365.4,249.91,356.64,248.26Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.6 297.58 337.54 299.58 326.32 298.58 329.6 297.58",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.4 349.69 335.57 354.74 361.69 353.59 336.73 359.19 313.4 349.69",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.35 381.97 328.51 386.98 348.23 386.98 324.29 388.9 316.27 383.42 320.35 381.97",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.13 391.86 371.98 391.86 376 394.88 337.13 391.86",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.97 362.78 310.45 357.32 306.96 359.19 329.97 362.78",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.81 370.45 365.15 367.94 368.26 369.19 335.81 370.45",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.01 338.39 376.71 337.25 379.47 339.58 345.01 338.39",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.26 331.73 342.21 328.77 326.13 322.78 320.69 322.78 339.87 330.82 368.26 331.73",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 308.35 345.4 313.08 386.41 316.39 382.71 313.64 345.01 311.27 332.25 308.35",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.73 280.96 318.46 281.87 322.99 284.06 336.73 280.96",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.05 273.47 342.94 271.62 378.74 284.06 342.75 274.75 329.05 273.47",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.44 266.31 352.07 254.77 330.88 261.41 337.13 263.09 354.83 260.54 373.44 266.31",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.86 258.31 399.01 271.62 395 271.62 366.86 258.31",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,248.26l16.07,1.83,25,13.88S365.4,249.91,356.64,248.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.6 297.58 337.54 299.58 326.32 298.58 329.6 297.58",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.81 302.69 346.67 305.43 377.19 308.35 346.67 306.86 335.81 302.69",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.25 294.65 349.57 295.5 382.02 301.05 348.56 297.58 332.25 294.65",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.6 284.97 341.19 282.83 375.63 290.82 340.9 284.06 327.6 284.97",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.88 278.17 342.34 277.84 377.19 286.82 342.01 279.27 330.88 278.17",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.53 271.62 340.93 269.63 323.53 272.92 323.53 271.62",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.99 276.37 329.05 276.37 322.99 277.84 322.99 276.37",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.54 251.08 353.84 248.26 375.63 256.12 354.04 250.09 337.54 252.19 337.54 251.08",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.73 275.14 368.87 267.38 393.03 277.1 393.73 275.14",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.45 253.01 354.09 252.19 393.73 264.96 354.26 253.5 350.45 253.01",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.78 258.31 385.56 253.25 399.01 259.59 399.78 258.31",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.05 314.01 344.26 318.66 378.74 321.44 343.94 320.27 329.05 314.01",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.77 328.38 341.08 334.29 375.63 335.08 340.92 335.08 325.77 328.38",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.36 344.33 339.87 341.05 327.6 336.05 339.34 342.87 369.36 344.33",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.62,325.8c-.28-.1-23.78-.71-23.78-.71l23.41,2.17Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.04 345.19 336.25 350.69 353.89 350.69 336.06 351.77 311.48 346.71 311.04 345.19",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,357.86c0,.05-24.51,2.74-24.51,2.74l24.3-1.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.27,356.14c-.33-.16,15.22,3.09,15.22,3.09S321.81,358.91,316.27,356.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.07 362.78 331.49 367.94 310.07 364.43 310.07 362.78",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.08 370.45 332.25 374.59 359.33 374.04 332.25 375.99 314.08 370.45",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.68 365.36 357.67 365.36 342.08 366.13 338.68 365.36",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,380.86l5.84,2.55s31.06-.25,30.5,0-30.62,1.35-30.62,1.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.26,388.9s-29,.73-28.39.73h24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.65,382.81s-4.76-.48-4.39,0,4.15,1.11,4.15,1.11Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.99 391.86 327.99 392.9 354.84 394.88 327.87 394.24 322.99 391.86",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.51,183.52c6.44,2.86,18.56,2.47,23.21-7.72s4.32-18.93-6.2-23.83-23.78,1.35-24.91,10.62S261.35,179,271.51,183.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,378.61a9.83,9.83,0,0,0,1.5-3.23h0s3.17-3.62,13.23-5.9l.89-4.53a3.82,3.82,0,0,0-1.84-4,2.16,2.16,0,0,0-.61-.24,24.78,24.78,0,0,0-3.33-.27,92.34,92.34,0,0,0-11.17.64l.05.8,7-.12c2.39,0-.29,2-2.82,2.65s-5.19,2-5,7.19C145.67,377.74,146.06,380.25,147.46,378.61Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.79,369.12s-12.92,3.43-15.83,6.26c0,0-1.78-4.87,4.88-8.33,8.62-4.47,6.79-6.3,6.79-6.3a21.28,21.28,0,0,1,3.69,1.43C166.58,363.52,164.79,369.12,164.79,369.12Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.28,409.8a9.83,9.83,0,0,0-3.52.59h0s-4.77-.56-12.35-7.58l-4.23,1.84A3.78,3.78,0,0,0,326,408.4a2,2,0,0,0,.13.64,25.32,25.32,0,0,0,1.67,2.9,92.32,92.32,0,0,0,6.84,8.85l.64-.49-4.08-5.74c-1.37-1.95,1.79-.87,3.78.83s4.55,3.17,8.75.05C348.57,411.78,350.42,410,348.28,409.8Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.65,400.88s10.13,8.72,14.11,9.51c0,0-3,4.22-9.62.68-8.56-4.58-9.05-2-9.05-2a21.26,21.26,0,0,1-.9-3.86C325,402.56,330.65,400.88,330.65,400.88Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,199.11c3.3,2.25,8.73,23.11,10.37,24.45s13.77-5.17,13.77-5.17l2.65,5.9s-18.32,11.21-20.84,9.1-10.76-24.68-10.76-24.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,199.11c3.3,2.25,8.73,23.11,10.37,24.45s13.77-5.17,13.77-5.17l2.65,5.9s-18.32,11.21-20.84,9.1-10.76-24.68-10.76-24.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,219.13l12.47,12.61s38.1,13,47.6-.81c0,0-4.14-20.74-14.82-24.29S218.76,219.13,218.76,219.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,219.13l12.47,12.61s38.1,13,47.6-.81c0,0-4.14-20.74-14.82-24.29S218.76,219.13,218.76,219.13Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.54,223.85l7.55-4.11,3.56-8.46a40.86,40.86,0,0,1,4.35,1.77c.5.39-1.6,7.38-2.13,7.82s-3.53.79-3.53.79l-7.19,4.55Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,188.22s24.73-.57,42.8,10.89A184.85,184.85,0,0,1,275,240.38l-36.26-6s3.88-10.33-.42-31Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,188.22s24.73-.57,42.8,10.89A184.85,184.85,0,0,1,275,240.38l-36.26-6s3.88-10.33-.42-31Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,187.09c5,21.24-17,40.25-33.79,40.48l-4.34-9.21,17.91-7.47,9.53-22.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,194.47s-3.37,29.7.34,36.46c0,0,6.33-11.59,7.76-31.33A34,34,0,0,0,278.49,194.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,187.09c5,21.24-17,40.25-33.79,40.48l-4.34-9.21,17.91-7.47,9.53-22.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.49,194.47s-3.37,29.7.34,36.46c0,0,6.33-11.59,7.76-31.33A34,34,0,0,0,278.49,194.47Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.5,187.38S255,185,247.57,189.57l4.57,3.24-3.39,3.83A45.6,45.6,0,0,1,244,216.48s8.12-8.29,10.86-17.35S256.36,188,259.5,187.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.16,191.4s5.36,1.16,10,7.34l-2.86.53,2.78,4.83-7,15.6s-.74-12-.39-19.24A16.34,16.34,0,0,0,274.16,191.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.5,187.38S255,185,247.57,189.57l4.57,3.24-3.39,3.83A45.6,45.6,0,0,1,244,216.48s8.12-8.29,10.86-17.35S256.36,188,259.5,187.38Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.16,191.4s5.36,1.16,10,7.34l-2.86.53,2.78,4.83-7,15.6s-.74-12-.39-19.24A16.34,16.34,0,0,0,274.16,191.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.83,289.19c-6.05,24.94-23.51,58.14-26.92,64.57-2.66,5.06-13.21,6.76-26,8.24-24.67,2.86-57.9,7.39-57.9,7.39l0-7.78s67.1-15.81,68.19-19.42c1.52-5.11,3.31-29.41,4.91-49.86.19-2.28.37-4.51.54-6.66.28-3.54.54-6.83.76-9.67.52-6.51.84-10.73.84-10.73L275.05,240S282.39,258,274.83,289.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.83,289.19c-6.05,24.94-23.51,58.14-26.92,64.57-2.66,5.06-13.21,6.76-26,8.24-24.67,2.86-57.9,7.39-57.9,7.39l0-7.78s67.1-15.81,68.19-19.42c1.52-5.11,3.31-29.41,4.91-49.86.19-2.28.37-4.51.54-6.66.28-3.54.54-6.83.76-9.67.52-6.51.84-10.73.84-10.73L275.05,240S282.39,258,274.83,289.19Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,320.05c-3.38-7.4-32.5-53.53-32.5-53.53l-28.62,4.84c9.23,27.07,42.09,54.72,47.66,61.9s46.95,71.18,46.95,71.18l5.09-3.6S299.16,335.71,292,320.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.71,234.39l37.66,2.45-.69,4.32s-4,19.37-19.89,29.64l-24.91.56s-2.91-15.79,6.9-34.09Z",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "251.87 235.64 239.45 234.91 238.51 237.8 251.59 238.78 251.87 235.64"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "253.43 235.73 253.15 238.9 274.92 240.54 275.12 237.01 253.43 235.73"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269,241.16h-.07l-4-.23a1.2,1.2,0,0,1-.81-.39,1.16,1.16,0,0,1-.29-.85L264,237a1.17,1.17,0,0,1,1.24-1.1l4,.24a1.12,1.12,0,0,1,.81.39,1.14,1.14,0,0,1,.29.85l-.15,2.65a1.2,1.2,0,0,1-1.17,1.11Zm-3.82-4.24a.17.17,0,0,0-.17.16l-.16,2.66a.2.2,0,0,0,.17.18l4,.24h0a.19.19,0,0,0,.17-.17l.15-2.65a.16.16,0,0,0,0-.13.22.22,0,0,0-.12-.06l-4-.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.64,239.19h0l-1.51-.09a.5.5,0,0,1-.47-.53.5.5,0,0,1,.53-.47l1.5.09a.5.5,0,0,1,.47.53A.49.49,0,0,1,269.64,239.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,214l10.29-5.28a10.42,10.42,0,0,1,2.66-2.71c1.1-.51,10.8,1,10.8,1l-3.63,7.67s-7.18-.41-7.94-1l-9.41,5Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,188.22c-9.47,2.46,4.76,37.18,11,39.15s26.25-11.51,26.25-11.51l-3.44-5.78s-17.49,7-19.09,6.23-8.06-18.22-9.21-21.34S243.27,188.22,243.27,188.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.27,188.22c-9.47,2.46,4.76,37.18,11,39.15s26.25-11.51,26.25-11.51l-3.44-5.78s-17.49,7-19.09,6.23-8.06-18.22-9.21-21.34S243.27,188.22,243.27,188.22Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.75,215.86a.35.35,0,0,1-.4.27.34.34,0,0,1-.27-.4.33.33,0,0,1,.4-.27A.35.35,0,0,1,278.75,215.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35,217.34a.34.34,0,0,1-.4.27.35.35,0,0,1-.27-.4.34.34,0,0,1,.67.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.43,197.68l-12.71,32.94a1.75,1.75,0,0,1-2,1l-23.27-5.79a1.31,1.31,0,0,1-.92-1.77l12.7-32.94a1.76,1.76,0,0,1,2-1l23.27,5.8A1.3,1.3,0,0,1,328.43,197.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.43,197.68l-12.71,32.94a1.75,1.75,0,0,1-2,1l-22.21-5.53a1.29,1.29,0,0,1-.92-1.77l12.7-32.94a1.75,1.75,0,0,1,2-1l22.22,5.53A1.3,1.3,0,0,1,328.43,197.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.58,208.78a2.51,2.51,0,0,0-2.87,1.49A1.86,1.86,0,0,0,309,212.8a2.5,2.5,0,0,0,2.87-1.49A1.85,1.85,0,0,1,310.58,208.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,195.78s1.47-6.62,4.08-8,15.07.81,19.4,4.88a17,17,0,0,1,4.8,10l-5.57-2.36-8.45,9.52L260,196.5Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,195.78s1.47-6.62,4.08-8,15.07.81,19.4,4.88a17,17,0,0,1,4.8,10l-5.57-2.36-8.45,9.52L260,196.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.88,188.05c7.19.55,10.92,5.52,10,9.59l-4.47.62-3.6,9.8-1.42-10.89-4.51-2.87S258,187.51,264.88,188.05Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,198.77c-6.86-5.41-6.06-9.65-6.06-9.65,3.37-1.86,5.61-5.88,6.42-9a18,18,0,0,0,.54-3l7.95,7a30.76,30.76,0,0,0-2.61,3.56,13.27,13.27,0,0,0-1.41,2.92c-1,3,.51,4,.51,4C272.67,198.55,267.53,198.77,267.53,198.77Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.61,187.19a12.89,12.89,0,0,0-1,3.08c-3.58-2.17-5.13-6.46-5.78-9.89a18.17,18.17,0,0,0,.16-3l8.77,6A30.45,30.45,0,0,0,273.61,187.19Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.35,160.5c8.18,3.95,8.7,9.6,5.23,18.31-4.34,10.9-10.29,17.25-19.43,10.06C259.74,179.11,272.77,153.94,286.35,160.5Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.51,175.8a19.1,19.1,0,0,0,.74,4.54,2.49,2.49,0,0,1-2.6-.11Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.83,172.72c-.31.68-.93,1.06-1.38.85s-.57-.92-.26-1.6.92-1.06,1.38-.86S282.14,172,281.83,172.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.36,171.06l1.74.09S281.8,172.06,281.36,171.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.34,176.41c-.31.68-.93,1.07-1.38.86s-.57-.92-.26-1.6.92-1.07,1.38-.86S290.65,175.73,290.34,176.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.87,174.76l1.74.09S290.31,175.76,289.87,174.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,168.28a.35.35,0,0,1-.3-.18,4.4,4.4,0,0,0-3.21-2.09.34.34,0,0,1-.34-.36.35.35,0,0,1,.36-.35c2.36.06,3.74,2.35,3.8,2.44a.36.36,0,0,1-.13.49A.37.37,0,0,1,284.15,168.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,171.15l-.15,0a3.92,3.92,0,0,0-3.37-.21.35.35,0,0,1-.48-.14.34.34,0,0,1,.14-.48,4.59,4.59,0,0,1,4,.19.36.36,0,0,1,.17.47A.35.35,0,0,1,294,171.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,170s7.07-4.87,9-10.34c0,0,19.41,1.21,12.26,18,0,0,8.64-13.84-5.26-21S263,170.19,267.27,179.82C267.27,179.82,266.36,173,270.76,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,172.33a4,4,0,0,0-2.28-5.14c-2.67-.95-6.39,3.67-.69,8C269.11,175.77,270.05,175.14,271.26,172.33Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.39,152.44s6.17-1.38,10.12.58,4.22,4.9,4.22,4.9a5.8,5.8,0,0,1,5.1,1.57c2.46,2.27,3.91,8.8,1.3,15.79s-8.7,6-8.7,6,7.94-10.37-.52-17.11c0,0-2.77-3.32-6-1.31s-5.53,10.4-12.64,4.94S273.26,154.05,279.39,152.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.74,183.87a.36.36,0,0,1-.35-.31c-.16-1.27-2.29-2.71-3.1-3.15a.37.37,0,0,1-.14-.49.35.35,0,0,1,.48-.13c.13.07,3.22,1.8,3.46,3.68a.36.36,0,0,1-.3.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,153.75s-4.29-14.24-13.61-10.14S252.54,158,245,152s-11,1.78-14.66,4.15-10.14-1.19-8.41-4.15c0,0-4.75,3.63,3.67,7.45s12.55-4.16,15.23-1.14S253,167.34,258,163a10.36,10.36,0,0,1,10.46-1.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.81,167a5.34,5.34,0,0,1-1.89-.35,53.08,53.08,0,0,1-5.27-2.43c-3.72-1.88-7.24-3.66-9.2-2.11a.25.25,0,0,1-.35,0,.24.24,0,0,1,0-.35c2.21-1.74,5.87.11,9.73,2.06a53.41,53.41,0,0,0,5.23,2.42c3.26,1.21,6.36-1.4,9.1-3.71,2-1.66,3.82-3.22,5.56-3.27a.25.25,0,0,1,.26.24.26.26,0,0,1-.25.26c-1.56.05-3.35,1.55-5.24,3.15C260.2,164.78,257.61,167,254.81,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.5,154.49a2.9,2.9,0,0,1-1.75-.59.24.24,0,0,1-.06-.35.25.25,0,0,1,.34-.06c2.16,1.53,4.46-.77,6.7-3,1.58-1.58,3.07-3.07,4.53-3.25s3.28.78,5.44,2a27.28,27.28,0,0,0,11,4.16.25.25,0,0,1-.05.5,27.91,27.91,0,0,1-11.23-4.23c-2.07-1.21-3.71-2.16-5.12-2s-2.72,1.59-4.24,3.11C232.34,152.58,230.42,154.49,228.5,154.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.08,172.16a6.6,6.6,0,0,1-3.05-.89.25.25,0,0,1-.08-.35.24.24,0,0,1,.34-.07c.15.09,3.6,2.2,5.52-.7,4.94-7.51,6.71-9.35,9.72-8.05a.24.24,0,0,1,.13.33.26.26,0,0,1-.33.13c-2.54-1.1-4.07.22-9.11,7.87A3.59,3.59,0,0,1,277.08,172.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--sheets-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319,222.63l20.43-8s23.16,13.55,37.88,15.79l-25.46,5S324.3,230,319,222.63Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,288.27l15.52-14s26.53,4,47.23,14l-21.62,13.27S216,291.19,195.25,288.27Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83,306.16l19.94-6.88s17.3,18.49,31.09,18.49L99,328.75S74.63,319.42,70.83,306.16Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,236.88s26-3,44.47,11.32l-9.51,11.71s-22.85-9.66-42.85-4Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.05,346.24l25.08,4.28S385.36,365,367,367.62l-19.79-6.41S371.07,358.72,382.05,346.24Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,302.81s24.11-1.3,41.16,5.77l10.23-9.76s-26.77-11.73-44-5.87Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.29,395s12.05-12.69,42.14-16l18.24,8.22s-27.21,5.91-39.6,11.66Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,222.63l20.43-8s23.16,13.55,37.88,15.79l-25.46,5S324.3,230,319,222.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.25,288.27l15.52-14s26.53,4,47.23,14l-21.62,13.27S216,291.19,195.25,288.27Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83,306.16l19.94-6.88s17.3,18.49,31.09,18.49L99,328.75S74.63,319.42,70.83,306.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,236.88s26-3,44.47,11.32l-9.51,11.71s-22.85-9.66-42.85-4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.05,346.24l25.08,4.28S385.36,365,367,367.62l-19.79-6.41S371.07,358.72,382.05,346.24Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,302.81s24.11-1.3,41.16,5.77l10.23-9.76s-26.77-11.73-44-5.87Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.29,395s12.05-12.69,42.14-16l18.24,8.22s-27.21,5.91-39.6,11.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan1);
export default __webpack_public_path__ + "static/media/plan-1.c0280b7cfe269aeccd724bf03dac24cb.svg";
export { ForwardRef as ReactComponent };